import { Form, Button, Row, Col } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import React, { useState, useEffect } from "react";
import axios from "axios";
import WarehouseAddModal from './components/warehouse_add_modal';

export function AddInstallation() {
  var curr = new Date();
  curr.setDate(curr.getDate());
  var date = curr.toISOString().substr(0, 10);
  const [openModal, setOpenModal] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [addedItems, setAddedItems] = useState([]);
  const [info, setInfo] = useState({});
  const [test, setTest] = useState(false);
  const [fill_texts_dict, setFillTextsDict] = useState({    
  "NAME": { "label": "Nazwisko i imie", "placeholder": "", "error_text": "", "data_type": "TEXT", "value": "" },
  "PHONE_NUMBER": { "label": "Numer telefonu", "placeholder": "", "error_text": "", "data_type": "TEXT", "value": "" },
  "INSTALLATION_ADDRESS": { "label": "Adres", "placeholder": "", "error_text": "", "data_type": "TEXT", "value": "" },
  "PRICE": { "label": "Cena", "placeholder": "", "error_text": "", "data_type": "REAL", "value": 0 },
  "ADVANCE": { "label": "Zaliczka", "placeholder": "", "error_text": "", "data_type": "REAL", "value": 0 },
  "MODULES_NAME": { "label": "Nazwa modułów", "placeholder": "", "error_text": "", "data_type": "TEXT", "value": "" },
  "MODULES_QUANTITY": { "label": "Ilość modułów", "placeholder": "", "error_text": "", "data_type": "REAL", "value": 0 },
  "INVERTER_NAME": { "label": "Nazwa falownika", "placeholder": "", "error_text": "", "data_type": "TEXT", "value": "" },
  "INSTALLATION_POWER": { "label": "Moc instalacji", "placeholder": "", "error_text": "", "data_type": "REAL", "value": 0 },
  "LAST_CONTACT": { "label": "Ostatni kontakt", "placeholder": "", "error_text": "", "data_type": "DATE", "value": "2021-01-01" },
  "WHEN_CONTACT": { "label": "Kiedy się skontaktować", "placeholder": "", "error_text": "", "data_type": "DATE", "value": "2021-01-01" },
  "INSTALED_DATE": { "label": "Data zainstalowania", "placeholder": "", "error_text": "", "data_type": "DATE", "value": "2021-01-01" },
  "SIGN_DATE": { "label": "Data podpisania umowy", "placeholder": "", "error_text": "", "data_type": "DATE", "value": date },
  "OFFER_TYPE": { "label": "Typ oferty", "placeholder": "", "error_text": "", "data_type": "TEXT", "value": "" },
  "WHOS_CLIENT": { "label": "Czyj klient", "placeholder": "", "error_text": "", "data_type": "TEXT", "value": "" },
  "INFORMATIONS_FOR_SALES": { "label": "Informacja dla sprzedawców", "placeholder": "", "error_text": "", "data_type": "TEXT", "value": "" },
  "INFORMATIONS_FOR_ADMIN": { "label": "Informacja dla administracji", "placeholder": "", "error_text": "", "data_type": "TEXT", "value": "" },
  "INFORMATIONS_FOR_MONTAGE": { "label": "Informacje dla montażystów", "placeholder": "", "error_text": "", "data_type": "TEXT", "value": "" }
})
  const [select_elements_dict, setSelectTextsDict] = useState({
  "ROOF_TYPE": { "label": "Typ dachu", "placeholder": "", "error_text": "", "data_type": "TEXT", "elements": ["Dachówka", "Blachodachówka", "Trapez", "Rąbek", "Płaski Grunt", " "], "value": "" },
  "METER_APPLICATION": { "label": "Wniosek o licznik", "placeholder": "", "error_text": "", "data_type": "TEXT", "elements": [" ", "Zgłoszone", "Wymienione", "Nie zgłoszone"], "value": "Nie zgłoszone" },
  "DONATE_APPLICATION": { "label": "Wniosek o dotacje", "placeholder": "", "error_text": "", "data_type": "TEXT", "elements": [" ", "Zgłoszone", "Dotacja", "Nie zgłoszone"], "value": "Nie zgłoszone" },
  "MATERIALS_AVALIABLE": { "label": "Materiały dostępne", "placeholder": "", "error_text": "", "data_type": "TEXT", "elements": [" ", "Zamówione", "Na stanie", "Nie zamówione"], "value": "Nie zamówione" },
  "ORDER_CLEARED": { "label": "Rozliczony montaż", "placeholder": "", "error_text": "", "data_type": "TEXT", "elements": [" ", "Tak", "Nie"], "value": "Nie" },
  "BUILDING_TYPE": { "label": "Typ budynku", "placeholder": "", "error_text": "", "data_type": "TEXT", "elements": ["Dom", "Budynek gospodarczy", "Grunt", " "], "value": "" },
  "POTENTIAL_CLIENT": { "label": "Klient", "placeholder": "", "error_text": "", "data_type": "TEXT", "elements": [" ", "Potencjalny", "Pewny"], "value": "Pewny" },
  "APP_INSTALLED": { "label": "Aplikacja", "placeholder": "", "error_text": "", "data_type": "TEXT", "elements": [" ", "Zrobiona", "Nie zrobiona"], "value": "Nie zrobiona" },
  "PAYMENT_TYPE": { "label": "Typ wpłaty", "placeholder": "", "error_text": "", "data_type": "TEXT", "elements": ["Kredyt z wpłata", "Kredyt", "Gotówka", " "], "value": "" },
  "ZM_MADE": { "label": "ZM spisane", "placeholder": "", "error_text": "", "data_type": "TEXT", "elements": [" ", "Tak", "Nie"], "value": "Nie" },
  "MOUNTED": { "label": "Zamontowane", "placeholder": "", "error_text": "", "data_type": "TEXT", "elements": [" ", "Tak", "Nie"], "value": "Nie" },
  "FINISHED": { "label": "Zakończone", "placeholder": "", "error_text": "", "data_type": "TEXT", "elements": [" ", "Tak", "Nie"], "value": "Nie" }})

 

  let handleSubmit = event => {
    event.preventDefault();
    let json = {}
    for (var key in fill_texts_dict) {
      if (fill_texts_dict.hasOwnProperty(key)) {
        json[key] = fill_texts_dict[key]["value"]
      }
    }
    for (var key in select_elements_dict) {
      if (select_elements_dict.hasOwnProperty(key)) {
        json[key] = select_elements_dict[key]["value"]
      }
    }
    console.log(json)
    AddToDatabase()
  }

  function AddToDatabase() {
    let json = {}
    for (var key in fill_texts_dict) {
      if (fill_texts_dict.hasOwnProperty(key)) {
        json[key] = fill_texts_dict[key]["value"]
      }
    }
    for (var key in select_elements_dict) {
      if (select_elements_dict.hasOwnProperty(key)) {
        json[key] = select_elements_dict[key]["value"]
      }
    }

    json["WAREHOUSE_ITEMS"] = addedItems;
    console.log(json);
    axios.post(`https://fotodemo.srv22208.microhost.com.pl/add_installation.php`,
      json,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
      .then(res => {
        window.location.reload(false);
      })
  }

  function FillTextElement(element_key) {
    let control_by_type = <Form.Control type="text" placeholder={fill_texts_dict[element_key]["placeholder"]} defaultValue=' ' onChange={(e) => { fill_texts_dict[element_key]["value"] = e.target.value; }} />
    if (fill_texts_dict[element_key]["data_type"] === "REAL") {
      control_by_type = <Form.Control type='number' step="0.1" min='0' max='999999999' defaultValue='0' placeholder={fill_texts_dict[element_key]["placeholder"]} onChange={(e) => { fill_texts_dict[element_key]["value"] = e.target.value; }} />
    }
    else if (fill_texts_dict[element_key]["data_type"] === "DATE") {
      control_by_type = <Form.Control type='date' placeholder={fill_texts_dict[element_key]["placeholder"]} onChange={(e) => { fill_texts_dict[element_key]["value"] = e.target.value; }} />
    }

    return (
      <>
          <Form.Group controlId={element_key}>
            <Form.Label>{fill_texts_dict[element_key]["label"]}</Form.Label>
            {control_by_type}
            <Form.Text className="text-muted">{fill_texts_dict[element_key]["error_text"]}</Form.Text>
          </Form.Group>
      </>
    );
  }

  function SelectElement(element_key) {
    return (
      <>
          <Form.Group controlId={element_key}>
            <Form.Label>{select_elements_dict[element_key]["label"]}</Form.Label>
            <Form.Control as="select"
              onChange={(e) => {
                select_elements_dict[element_key]["value"] = e.target.value;
              }}
            >
              {
                select_elements_dict[element_key]["elements"].map((element) => {
                  return <option selected={true}>{element}</option>
                }
                )
              }
            </Form.Control>
          </Form.Group>
      </>
    );
  }

  let elements = []
  for (var key in fill_texts_dict) {
    if (fill_texts_dict.hasOwnProperty(key)) {
      elements.push(FillTextElement(key))
    }
  }

  for (var key in select_elements_dict) {
    if (select_elements_dict.hasOwnProperty(key)) {
      elements.push(SelectElement(key))
    }
  }

  const handleOpenModal = async () => {
    if(modalData.length > 1){
      console.log(modalData)
      let json = {}
      json["fill_text"] = fill_texts_dict;
      json["select"] = select_elements_dict;
      console.log(json);
      setInfo(json);
      setOpenModal(true)

    } else {
      let json = {}
      json["fill_text"] = fill_texts_dict;
      json["select"] = select_elements_dict;
      console.log(json);
      setInfo(json);
      const response = await axios.get(`https://fotodemo.srv22208.microhost.com.pl/warehouse/warehouse_items.php`);
      setModalData(response.data.solar_instalations.items);
      setOpenModal(true)
    }
  }  

  return (
    <>
      <link
        rel="stylesheet"
        href="https://maxcdn.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css"
        integrity="sha384-9aIt2nRpC12Uk9gS9baDl411NQApFmC26EwAOH8WgZl5MYYxFfc+NcPb1dKGj7Sk"
        crossorigin="anonymous"
      />
      <div className="px-md-5 pt-md-4">
          <Form>
            <Row>
            {elements.map((elem) => (
                   <Col className="m-0 col-12 col-md-6 col-lg-4"> {elem} </Col>
                ))}
              </Row>

              <Button className='my-4' variant="success" onClick={() => handleOpenModal()}>Magazyn</Button>
              <Row>
              {addedItems.map((item) => (
                <div className="d-flex flex-row">
                  <p className="mr-5" key={`added_item_${item.id}`}><strong>Nazwa części:</strong> {item.name}</p>
                  <p key={`added_item_quant_${item.id}`}><strong>Ilość:</strong> {item.assigned}</p>
                </div>

              ))}
              </Row>
            <Button variant="primary" type='submit' onClick={handleSubmit}>Dodaj</Button>
          </Form>
          <WarehouseAddModal getAddedItems={setAddedItems} passChildData={setOpenModal} show={openModal} setModalData={setModalData} modalData={modalData} info={info} addedItems={addedItems}/>
      </div>
    </>
  );
}

export default withRouter(AddInstallation);
